<template>
    <v-tooltip z-index="400" top :max-width="500" :disabled="!maxProductsTooltip">
        <template v-slot:activator="{ props }">
            <div
                v-bind="props"
                class="ag-checkbox-wrapper"
                :class="{ 'ag-checkbox-wrapper__centered': isCenteredHorizontally }"
            >
                <vuex-checkbox
                    :id="params.node.id + '-checkbox'"
                    :class="{ 'ag-checkbox': isCenteredHorizontally }"
                    :getter="() => isChecked"
                    :setter="value => setValue(value)"
                    :disabled="isDisabled"
                    :validations="params.validations && params.validations(params)"
                />
            </div>
        </template>
        <span>{{ maxProductsTooltip }}</span>
    </v-tooltip>
</template>

<script>
import { isFunction, get } from 'lodash';
import readonly from '@/js/mixins/readonly';

export default {
    mixins: [readonly],
    data() {
        return {
            isChecked: false,
        };
    },
    computed: {
        // Controls whether classes for centering the checkbox horizontally are applied
        isCenteredHorizontally() {
            return this.params.isCenteredHorizontally;
        },
        isDisabled() {
            return isFunction(this.params.isDisabled)
                ? this.params.isDisabled(this.params)
                : this.params.isDisabled || this.isReadOnly;
        },

        maxProductsTooltip() {
            return isFunction(this.params.maxProductsTooltip)
                ? this.params.maxProductsTooltip(this.params)
                : false;
        },
    },
    created() {
        this.refresh(this.params);
    },
    methods: {
        refresh(params) {
            // Ensure the internal state is set correctly when the component is first created.
            if (params.pathToData) {
                this.isChecked = get(params, params.pathToData);
            } else {
                this.isChecked = params.value;
            }
        },
        get,
        setValue(newValue) {
            //  set up local state
            this.isChecked = newValue;
            // set up agGrid column value
            const colId = this.params.column.colId;
            this.params.node.setDataValue(colId, newValue);
        },
    },
};
</script>

<style lang="scss">
@import '@style/base/_variables.scss';

// centers the checkbox within it's parent
.ag-checkbox-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;

    &__centered {
        justify-content: center;
    }

    // Removes the default 8px margin that comes in v-checkbox
    .ag-checkbox .v-input--selection-controls__input {
        margin: 0;
    }
}

.simple-checkbox {
    .v-icon {
        color: $promo-primary-colour;
        font-size: 2rem;
    }
    .v-input--selection-controls__ripple {
        height: 3rem;
        width: 3rem;
        top: calc(50% - 2.2rem);
    }
}
</style>
